import React from "react";
import Table from "./ui/Table";

const TableComponent = ({
  data,
  tableColumn,
  tableHeader,
  acceptClick = () => {},
  rejectClick = () => {},
  dropDownClick = () => {},
  viewClick = () => {},
  editClick = () => {},
  deleteClick = () => {},
  openStatusEditModal = () => {},
  showArchived = false,
  orderEditClick = () => {},
}) => {
  return (
    <Table
      headers={tableHeader}
      columns={tableColumn}
      data={data}
      viewClick={viewClick}
      acceptClick={acceptClick}
      rejectClick={rejectClick}
      dropDownClick={dropDownClick}
      editClick={editClick}
      deleteClick={deleteClick}
      openStatusEditModal={openStatusEditModal}
      showArchived={showArchived}
      orderEditClick={orderEditClick}
    />
  );
};

export default TableComponent;
